import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";
import { FAQ } from "../lib/faq";
import { useSEO } from "../lib/useSEO";
import { PageDecor } from "../components/decor/PageDecor";

export default function Faq() {
  useSEO({
    title: "FAQ — Questions fréquentes · 1000 ARTS Cugy VD",
    description: "Toutes les réponses aux questions fréquentes sur 1000 ARTS : inscription, tarifs, cours d'essai, spectacle, compétition, stages, réductions famille.",
    canonical: "/faq",
  });

  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div data-testid="page-faq" className="pt-32 pb-24 relative overflow-hidden mesh-bg">
      <PageDecor />
      <div className="max-w-[1000px] mx-auto px-6 md:px-12 relative z-10">
      <div className="eyebrow mb-3">Questions fréquentes</div>
      <h1 className="font-display text-5xl md:text-7xl tracking-tight leading-tight">
        On répond <span style={{ color: "var(--primary)" }}>à tout</span>
      </h1>
      <p className="mt-6 text-lg text-[var(--muted)] max-w-2xl leading-relaxed">
        Toutes les réponses aux questions les plus fréquentes sur les inscriptions, les tarifs, le spectacle, la compétition et le fonctionnement de l'école. Une question qui n'est pas dans la liste&nbsp;? <Link to="/contact" className="underline" style={{ color: "var(--primary)" }}>Contacte-nous</Link>.
      </p>

      {/* FAQ items */}
      <div className="mt-10 space-y-2" data-testid="faq-list">
        {FAQ.map((item, i) => {
          const open = openIdx === i;
          return (
            <div key={i} className="card-flat" data-testid={`faq-${i}`} style={{ padding: 0 }}>
              <button
                onClick={() => setOpenIdx(open ? -1 : i)}
                data-testid={`faq-toggle-${i}`}
                className="w-full flex items-center justify-between p-5 text-left"
                aria-expanded={open}
              >
                <span className="font-display text-lg pr-4">{item.q}</span>
                <ChevronDown
                  size={20}
                  style={{ color: "var(--primary)", transition: "transform 0.2s", transform: open ? "rotate(180deg)" : "" }}
                />
              </button>
              {open && (
                <div className="px-5 pb-5 text-[var(--muted)] text-sm leading-relaxed">{item.a}</div>
              )}
            </div>
          );
        })}
      </div>

      {/* CTA */}
      <section className="mt-16">
        <div className="card-flat text-center" style={{ padding: "40px 24px" }}>
          <h3 className="font-display text-2xl md:text-3xl">Une autre question&nbsp;?</h3>
          <p className="text-[var(--muted)] mt-3">On répond dans les 24h en semaine.</p>
          <Link to="/contact" data-testid="faq-cta-contact" className="btn-primary mt-6 inline-flex">
            Nous contacter <ArrowRight size={16} />
          </Link>
        </div>
      </section>
      </div>
    </div>
  );
}
